import { SearchResultsCardInterface } from 'common/types/entities/search-results-interface'
import {
  containerCss,
  marginCss,
  mobileMarginCss,
  mobileTextCss,
  textCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'
import { BaseSearchResultsUiStylesInterface } from '../../ui'

export const SearchResultsCardUi = styled.div<SearchResultsCardInterface>`
  display: flex;
  gap: 32px;
  border-bottom: 1px solid #e5e7eb;
  justify-content: space-between;
  overflow: hidden;
  ${containerCss}

  ${p => p.theme.phone} {
    flex-direction: row;
    gap: 25px;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      flex-direction: row;
      gap: 25px;
    `}
`

export const SearchResultsCardContainerUi = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;

  ${p => p.theme.phone} {
    padding: 0;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      padding: 0;
    `}

`

export const SearchResultsCardTitleUi = styled.h3<BaseSearchResultsUiStylesInterface>`
  ${textCss};
  ${marginCss};

  ${p => p.theme.isEditorMobileMode && mobileTextCss}
  ${p => p.theme.isEditorMobileMode && mobileMarginCss}
  ${p => p.theme.phone} {
    ${mobileMarginCss}
    ${mobileTextCss}
  }
`
export const SearchResultsCardTitleLinkUi = styled.a`
  color: inherit;

  &:hover {
    color: inherit;
  }
`

export const SearchResultsCardContentUi = styled.p<BaseSearchResultsUiStylesInterface>`
  ${textCss};
  ${marginCss};

  mark {
    color: inherit;
    font-weight: 700;
    background-color: transparent;
  }
  ${p => p.theme.isEditorMobileMode && mobileTextCss}
  ${p => p.theme.isEditorMobileMode && mobileMarginCss}
  ${p => p.theme.phone} {
    ${mobileMarginCss}
    ${mobileTextCss}
  }
`
export const SearchResultsCardDateUi = styled.div<BaseSearchResultsUiStylesInterface>`
  text-transform: uppercase;
  ${textCss};
  ${marginCss};
  ${p => p.theme.isEditorMobileMode && mobileTextCss}
  ${p => p.theme.isEditorMobileMode && mobileMarginCss}
  ${p => p.theme.phone} {
    ${mobileMarginCss}
    ${mobileTextCss}
  }
`

export interface SearchResultsCardImageWrapperUiStylesInterface {
  hasImage: boolean
}

export const SearchResultsCardImageWrapperUi = styled.div<SearchResultsCardImageWrapperUiStylesInterface>`
  width: 337px;
  height: auto;
  max-height: 187px;
  overflow: hidden;
  flex-shrink: 0;
  ${p =>
    p.hasImage &&
    css`
    background-color: #fefefe;
  `}


  ${p => p.theme.phone} {
    width: 106px;
    max-height: 65px;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      width: 106px;
      max-height: 65px;
    `}
`

export const SearchResultsCardImageUi = styled.img`
  width: 100%
`
